
import axios from 'axios';
import { ISectionComponentMap } from '../../app/pages/analytics/Analytics';
import { IComponent } from '../../interfaces/Analytics/Analytics';

const API_URL = process.env.REACT_APP_API_URL;

const TEMPLATE = `${API_URL}analytics/template`;
const ACCESS_TEMPLATE = `${API_URL}analytics/template/access`;
const POSITION = `${API_URL}menu-analytics/position`;
const POSITION_DASHBOARD = `${API_URL}menu-analytics/dashboard`;

export const updatePositionAnalytic = async (
  dataPosition:ISectionComponentMap[], id: string ,token: string
) => {
  return axios.post(
    POSITION+"?templateId="+id,
    {
      dataPosition,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  );
};
export const updatePositionAnalyticDashboard = async (
  dataPosition:{componentId:string}[] ,token: string
) => {
  return axios.post(
    POSITION_DASHBOARD,
    {
      data: dataPosition,
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  );
};

export const insertTemplate = async (
  name: string,description:string,token: string
) => {
  return axios.post(
    TEMPLATE,
    {
      name,
      description
      
    },
    {
      headers: {
        'X-Auth-token': token,
      },
    }
  );
};

export const updateTemplate = async (
    name: string,description: string,id: string, token: string
  ) => {
    return axios.put(
      TEMPLATE+"?templateId="+id,
      {
        name,description
      },
      {
        headers: {
          'X-Auth-token': token,
        },
      }
    );
  };
export const updateAccessTemplate = async (
    dataUsers: {userId:string, access:string}[],id: string, token: string
  ) => {
    return axios.put(
      ACCESS_TEMPLATE+"?templateId="+id,
      {
        dataUsers,
      },
      {
        headers: {
          'X-Auth-token': token,
        },
      }
    );
  };

export const deleteTemplate = async (id: string, token: string) => {
    return axios.delete(
        TEMPLATE+"/"+id, 
        {
      headers: {
        'X-Auth-token': token,
      },
    });
  };

